import * as React from 'react'
import { styled } from '@design/pt-ui'
import { Oval } from 'react-loader-spinner'

const Overlay = styled('div')({
  position: 'absolute',
  backgroundColor: 'rgba(0,0,0,0.2)',
  height: '100%',
  width: '100%',
  zIndex: 1100,
  top: 0,
  left: 0,
})

const CenteredAbsolute = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  transform: 'translate(-50%, -50%)',
})

const CenteredFlex = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
})

const sizes = {
  small: {
    height: 25,
    width: 25,
  },
  medium: {
    height: 50,
    width: 50,
  },
  large: {
    height: 75,
    width: 75,
  },
}

interface ILoaderProps {
  size?: 'small' | 'medium' | 'large'
  variant?: 'overlay' | 'flex'

  type?: string
  color?: string
  message?: string
}

function Loader(props: ILoaderProps) {
  const { size = 'medium', color = '#591841', message } = props

  const SpinnerContainer =
    props.variant === 'flex' ? CenteredFlex : CenteredAbsolute

  const spinner = (
    <SpinnerContainer className="cp-loader">
      <Oval
        color={color}
        secondaryColor={color}
        height={sizes[size].height}
        width={sizes[size].width}
      />
      <div> {message} </div>
    </SpinnerContainer>
  )

  return props.variant === 'overlay' ? (
    <Overlay className="cp-loader">{spinner}</Overlay>
  ) : (
    <div className="cp-loader">{spinner}</div>
  )
}

export default Loader
